import React from 'react';

function View404() {
  return (
    <div>
      <h5>Página no encontrada</h5>
    </div>
  );
}

export default View404;
